var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6V3C2 2.44772 2.44772 2 3 2H6",
    stroke: "#7D899D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H3C2.44772 22 2 21.5523 2 21L2 18",
    stroke: "#7D899D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.001 2L21.001 2C21.5533 2 22.001 2.44772 22.001 3V6",
    stroke: "#7D899D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18V21C22 21.5523 21.5523 22 21 22H18",
    stroke: "#7D899D",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.0001V18.2C5 18.6418 5.35817 19 5.8 19C6.24183 19 6.6 18.6418 6.6 18.2V12.0001V5.80021C6.6 5.35838 6.24183 5.00021 5.8 5.00021C5.35817 5.00021 5 5.35838 5 5.80021V12.0001Z",
    fill: "#7D899D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.9984V18.5843C8 18.8122 8.18776 18.9953 8.41556 18.9896C8.64425 18.9837 8.82676 18.7969 8.82722 18.5681L8.84056 11.9879L8.84943 5.42521C8.84974 5.19058 8.65963 5.00021 8.425 5.00021C8.19028 5.00021 8 5.19049 8 5.42521V11.9984Z",
    fill: "#7D899D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.0001V18.5C19 18.7761 18.7761 19 18.5 19C18.2239 19 18 18.7761 18 18.5V12.0001V5.50021C18 5.22407 18.2239 5.00021 18.5 5.00021C18.7761 5.00021 19 5.22407 19 5.50021V12.0001Z",
    fill: "#7D899D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.0001V18.5C14 18.7761 13.7761 19 13.5 19C13.2239 19 13 18.7761 13 18.5V12.0001V5.50021C13 5.22407 13.2239 5.00021 13.5 5.00021C13.7761 5.00021 14 5.22407 14 5.50021V12.0001Z",
    fill: "#7D899D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0001V18.25C12 18.6642 11.6642 19 11.25 19C10.8358 19 10.5 18.6642 10.5 18.25V12.0001V5.75021C10.5 5.336 10.8358 5.00021 11.25 5.00021C11.6642 5.00021 12 5.336 12 5.75021V12.0001Z",
    fill: "#7D899D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12V18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18V12V6C15 5.44771 15.4477 5 16 5C16.5523 5 17 5.44771 17 6V12Z",
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.c3c62a8be2e59853f4dc28b6856852dc.svg";
export { ForwardRef as ReactComponent };